<template>
  <form class="byForm" @submit="submitForm">
    <transition name="el-zoom-in-top">
      <slot name="submitError">
        <div :key="errorMsg" class="error-submit" v-if="errorMsg">
          <!-- <div class="error-box"  >
          required -->
          {{ errorMsg }}
        </div>
      </slot>
    </transition>
    <slot></slot>
  </form>
</template>

<script>
import Emitter from "@/utils/emitter";
import validator from "./validator";

export default {
  name:'ByForm',
  mixins: [Emitter],

  props: {
    model: {},
    rules: {},
    submit: {
      type: Boolean,
      default: false,
    },
    errorIsNoText: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      byForm: this,
    };
  },
  data() {
    return {
      ruleKeys: [],
      errors: [],
      errorMsg: "",
    };
  },
  mounted() {
  //   console.log("🚀 ~  this.$el",  this.$el)
  //   console.log("🚀 ~ this.$el.querySelectorAll('input')", this.$el.querySelectorAll('input'))
  //   this.$el.querySelectorAll('input')[0].addEventListener('blur',()=>{
  //   console.log("🚀 ~ querySelectorAll")
  // this.$el.querySelectorAll('input')[1].focus()
  //     this.$el.querySelectorAll('input')[1].click()
  //   })
    // this.$el.querySelectorAll('input')[0].blur = function(e){
    // console.log("🚀 ~ querySelectorAll")
      
    
    // }

    if (this.rules) {
      this.ruleKeys = Object.keys(this.rules);
    }
  },
  methods: {
    submitForm() {
      if (this.submit) {
        this.$emit('submitForm', true)
      }
    },
    // isTriggerFormItem 提交时  是否猝发 FormItem 验证
    validate(cb, isTriggerFormItem=true) {
      // Object.keys(rules).forEach((vk,index)=>{
      //     if(this.model[vk].length===0){

      //     }

      // })
      // debugger
      this.ruleKeys = Object.keys(this.rules);

      if (isTriggerFormItem) {
        this.broadcast("ByFormItem", "by.form.submit", this.ruleKeys);
      }
      let errors = [];
      for (const vk of this.ruleKeys) {
        if (!this.model[vk] || this.model[vk].length === 0) {
          if (
            Object.prototype.toString.call(this.rules[vk]) === "[object Object]"
          ) {
            this.rules[vk] = [this.rules[vk]];
          }
          validator.add(this.model[vk]||'', this.rules[vk]);
          let err = validator.start();
          errors.push({ err, vk });
          // return cb({ err, vk });
        }
      }
      // console.log("🚀 ~ errors", errors);
    // debugger
      if (errors.length > 0) return cb(false, errors, this.submitCallback);
      return cb(true, [], this.submitCallback);
    },
    submitCallback(msg) {
      this.errorMsg = msg;
    },
    // asyncAddErr(){
    //   return new Promise((resolve,reject) => {
    //     let errors = []
    //     for (const vk of this.ruleKeys) {
    //           validator.add(this.model[vk],this.rules[vk])
    //         let err=validator.start()
    //         // if(typeof =='string'){
    //            errors.push({err,vk})
    //         // }
    //     }
    //     console.log("🚀 ~ errors", errors)
    //   })

    // }
  },
};
</script>


<style lang="scss" scoped>
.byForm {
  position: relative;
}
.error-submit {
  position: absolute;
  top: -20px;
  color: red;
}
</style>